export const GET_SIMULATIONS = "Simulations/GET_SIMULATIONS";
export const GET_SIMULATIONS_SUCCESSFUL = "Simulations/GET_SIMULATIONS_SUCCESSFUL";
export const GET_SIMULATIONS_FAILED = "Simulations/GET_SIMULATIONS_FAILED";
